import React from 'react';
import { Container, Row } from 'react-bootstrap';
import { withAuthorization } from '../Session';
import AllList from './AllList';

class GManager extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Container>
                <AllList {...this.props} />
            </Container>
        );
    }
}

const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(GManager);
